import { useCustomMutation } from "data/modules/api/hooks/useCustomMutation";
import { UC_CACHE_TIME } from "../constants/cache.constants";
import { useCustomQuery } from "data/modules/api/hooks/useCustomQuery";
import { UC_APIS } from "../constants/api.constants";
import { UC_QUERY_KEYS } from "../constants/queryKeys.constants";

export const useSebiReportsVisibility = () =>
  useCustomQuery({
    url: UC_APIS.sebiReportsVisibility,
    queryKey: [UC_QUERY_KEYS.sebiReportsVisibility],
    staleTime: UC_CACHE_TIME.FIVE_MINUTES_MS,
    retry: false,
    onError: () => {},
  });

export const useRequestReport = (options = {}) =>
  useCustomMutation({ url: UC_APIS.reportUpload, ...options });
